import { render, staticRenderFns } from "./BatchTemplate.vue?vue&type=template&id=2508860a&scoped=true&"
import script from "./BatchTemplate.vue?vue&type=script&lang=js&"
export * from "./BatchTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BatchTemplate.vue?vue&type=style&index=0&id=2508860a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508860a",
  null
  
)

export default component.exports